const regexPatterns = {
  email:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  url: /(https?:\/\/)?[\w\-~]+(\.[\w\-~]+)+(\/[\w\-~.@:%][^,\n\s]*)*(#[\w-]*)?(\?[^\s]*)?/gi,
};

export default regexPatterns;
